import classNames from 'classnames'
import { useRouter } from 'next/router'
import { EditorLayoutWithFiles } from 'website/src/components/editor/Layout'
import { SiteCursors } from 'website/src/components/editor/SiteCursors'
import { TipTap } from 'website/src/components/editor/TipTap'
import { MarkdownCodeEditor } from 'website/src/components/editor/markdown-editor'
import {
    useEditorMode,
    useIsMounted,
    useRootProps,
} from 'website/src/lib/hooks'

export function EditorsWithLayout({}) {
    const router = useRouter()
    const mode = useEditorMode()
    const props = useRootProps()
    const mounted = useIsMounted()
    if (!mounted) {
        return null
    }
    const hasParseErrors = props.parseErrors.filter(Boolean).length > 0
    const sideBySide = mode === 'split' && !hasParseErrors
    const showMarkdown = hasParseErrors || mode === 'markdown' || sideBySide
    return (
        <EditorLayoutWithFiles>
            <SiteCursors />
            <div
                className={classNames(
                    'flex flex-row grow',
                    sideBySide && '[&>div]:max-w-[50%]',
                )}
            >
                <div
                    key={String(router.query.k || 0)}
                    className={classNames(
                        'content-visibility grow',
                        'w-full flex flex-col',
                        // 'max-w-[800px] mx-auto',
                        mode === 'markdown' && 'hidden',
                    )}
                >
                    <TipTap />
                </div>
                {showMarkdown && (
                    <div className='grow '>
                        <MarkdownCodeEditor />
                    </div>
                )}
            </div>
        </EditorLayoutWithFiles>
    )
}
